import { Component } from '@angular/core';

@Component({
  selector: 'app-property-card-footer',
  imports: [],
  templateUrl: './property-card-footer.html',
  styleUrl: './property-card-footer.scss',
  standalone: true
})
export class PropertyCardFooterComponent {

}
